import { Grid2 } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../../../../assets/logos/admin_logo.svg";
import "../../../../DrugAssignmentBatchRelease/DrugAssignment.css";

const RandomizationTreatmentConfirmation = ({
  setShowConfirm,
  data,
  id,
  subjectName,
}) => {
  const navigate = useNavigate();

  const fields = [
    { label: "Drug Kit Number", key: "drugKitNumber" },
    { label: "Enrollment Treatment Errors", key: "enrollmentTreatmentErrors" },
    { label: "Date of Birth", key: "keyDateOfBirth" },
    { label: "Gender", key: "keyGender" },
    { label: "Initials", key: "patientInitials" },
    { label: "Patient Status", key: "patientStatus" },
    { label: "Subject Number", key: "subjectNumber" },
    { label: "Visit", key: "visitName" },
  ];

  const email = localStorage.getItem("email");

  return (
    <div className="content-body">
      <p className="bread-crumbs-link-container" style={{ fontWeight: "600" }}>
        <Link className="bread-crumbs-link" to="/">
          Home
        </Link>{" "}
        |{" "}
        <Link
          className="bread-crumbs-link"
          to="/subject"
          onClick={() => setShowConfirm(false)}
        >
          Subject Management
        </Link>
        |{" "}
        <button
          className="bread-crumbs-btn"
          onClick={(e) => {
            navigate("/update-subject", {
              state: {
                id: id,
              },
            });
          }}
        >
          {subjectName}
        </button>
        |{" "}
        <Link
          className="bread-crumbs-link"
          // to="/subject-randomization-treatment"
          onClick={() => setShowConfirm(false)}
        >
          Register Randomization or Treatment Error
        </Link>
        - <b style={{ color: "gray" }}>{localStorage?.getItem("studyName")}</b>
      </p>
      <Grid2
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{ width: "100%", margin: "0 auto" }}
      >
        <Grid2 item md={6}>
          <p className="page-heading">
            Genesis StudyPortal Confirmation of Enrollment Treatment Error
            Registration
          </p>
        </Grid2>
      </Grid2>
      <div className="heading-container">
        <h4>
          Confirmation of Enrollment Treatment Error Registration Genesis
          StudyPortal
        </h4>
      </div>
      <div className="inner-heading-container">
        <img className="admin-logo logo-image" src={logo} alt="Genesis Logo" />
        <div className="data-block">
          <div className="data-inner-block">
            <span className="data-inner-block-text">User Name : </span>
            <span style={{ color: "white" }}> {email}</span>
          </div>

          <div className="data-block">
            <span className="data-inner-block-text">
              System Transaction Date :
            </span>
            <span style={{ color: "white" }}>
              {" "}
              {new Date().toLocaleDateString()}
            </span>
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "20px",
          width: "100%",
        }}
      >
        {/* CENTERED BLOCK */}
        <div
          style={{
            width: "600px",
          }}
        >
          {fields.map(({ label, key }) => (
            <div
              key={key}
              style={{
                display: "flex",
                alignItems: "flex-start",
                marginBottom: "8px",
                gap: "100px",
                width: "100%",
              }}
            >
              {/* LABEL */}
              <span
                style={{
                  width: "220px",
                  fontWeight: "600",
                  minWidth: "220px",
                  textAlign: "right",
                  wordBreak: "break-word",
                }}
              >
                {label}:
              </span>

              {/* VALUE */}
              <span
                style={{
                  flex: 1,
                  fontWeight: "400",
                  textAlign: "left",
                  wordBreak: "break-word",
                }}
              >
                {data?.[key] === "n/a" ? "N/A" : data?.[key] || "N/A"}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="note-container">
        <span
          style={{
            fontWeight: "600",
            color: "#585858",
          }}
        >
          Note :
        </span>
        <span>The Enrollment Treatment Is Registered Successfully.</span>
      </div>
      <div
        style={{
          height: "20px",
        }}
      ></div>
      <div className="footer-container">
        <span>
          Genesis {new Date().getFullYear()}-Please contact Genesis Support for
          assistance at Genesis.com/support
        </span>
      </div>

      <Grid2
        alignItems={"center"}
        justifyContent="center"
        container
        gap={3}
        sx={{ marginTop: "2%" }}
      >
        <Grid2 item md={6}>
          <button
            className="create-btn"
            onClick={() => {
              navigate("/");
            }}
          >
            Home
          </button>
        </Grid2>
      </Grid2>
    </div>
  );
};

export default RandomizationTreatmentConfirmation;
